import React from 'react';

export default function ReportHeader({ id }) {
  return(
    <React.Fragment>
      <div className="report-header">
        <div className="report-logo">
          P2P<span>AUTO</span>
        </div>
        <h1>Vehicle Inspection Report</h1>
        <div className="report-id">
          Report ID: P2P-{id}
        </div>
      </div>
      <div className="report-header-mobile">
        <h2>Vehicle Inspection Report</h2>
        <div className="report-id-mobile">
          Report ID: P2P-{id}
        </div>
      </div>
    </React.Fragment>
  )
}

